<template>
  <div class="quick-report">
    <div id="OD" class="">
      <ReportQuickDiagnosisSelectionTab
        v-if="hasData"
        :laterality="'right'"
        :exam="exam"
        :entries="selectedEntries.right"
        @selected-entries="rightEyeSelection">
      </ReportQuickDiagnosisSelectionTab>
    </div>
    <div id="OE" class="">
      <ReportQuickDiagnosisSelectionTab
        v-if="hasData"
        :laterality="'left'"
        :exam="exam"
        :entries="selectedEntries.left"
        @selected-entries="leftEyeSelection">
      </ReportQuickDiagnosisSelectionTab>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.quick-report {
  display:                              flex;
  flex-direction:                       column;
  gap:                                  19px;
}
</style>

<script>
import ReportQuickDiagnosisSelectionTab from './ReportQuickDiagnosisSelectionTab.vue'

export default {
  name: 'ReportQuick',
  props: ['exam', 'observation', 'loaded_entries'],
  components: {
    ReportQuickDiagnosisSelectionTab,
  },
  data: () => ({
    loading: true,
    hasData: false,
    selectedEntries: {
      right: ['000_1'],
      left: ['000_1']
    },
    // observationValue: ""
  }),
  watch: {
    // Observe a prop `loaded_entries`
    loaded_entries: {
      handler(newVal) {
        if (newVal && (newVal.right.length > 0 || newVal.left.length > 0)) {
          // Crie uma cópia para evitar mutação da prop
          this.selectedEntries = { ...newVal };
        }
      },
      // `immediate: true` garante que o watcher seja executado
      // na primeira vez que o componente é montado.
      immediate: true,
      deep: true
    }
  },
  mounted () {
    const hasEntries = !_.isEmpty(this.loaded_entries.right) || !_.isEmpty(this.loaded_entries.left)
    if (hasEntries) {
      this.selectedEntries = this.loaded_entries
    }

    this.entriesChanged() // force parent update
    // this.observationValue = this.observation ? this.observation : ""

    this.hasData = true
  },
  methods: {
    rightEyeSelection(entries) {
      this.selectedEntries.right = entries.filter(x => !_.isEmpty(x)).sort()
      this.entriesChanged()
    },
    leftEyeSelection(entries) {
      this.selectedEntries.left = entries.filter(x => !_.isEmpty(x)).sort()
      this.entriesChanged()
    },
    entriesChanged() {
      let quickReportValues = {
        selectedEntries: this.selectedEntries,
        // observation: this.observationValue,
      }

      this.$emit('entries-changed', quickReportValues);
    }
  }
}
</script>
